let Workday = [
    { date: '2021/4/25', name: '补劳动节的班' },
    { date: '2021/5/8', name: '补劳动节的班' },
    { date: '2021/9/18', name: '补中秋节的班' },
    { date: '2021/9/26', name: '补国庆节的班' },
    { date: '2021/10/9', name: '补国庆节的班' },
]
this.$get();
export default Workday
